// IMPORTANT: THIS FILE IS AUTO GENERATED AND OVERWRITTEN ON BUILD!
/* tslint:disable */
export const GITVERSION = {
  "dirty": true,
  "raw": "dev",
  "hash": "dev",
  "distance": 0,
  "tag": "dev",
  "semver": {
    "raw": "dev",
    "major": 0,
    "minor": 0,
    "patch": 0,
    "prerelease": [],
    "build": [],
    "version": "dev"
  },
  "suffix": "dev",
  "semverString": "dev"
};
/* tslint:enable */
